import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { gql } from '@apollo/client'
import { RETRIEVEX_REPORT_QUERY } from '../../../graphql.js'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { csvUrl, getData, getInputParams, sortColumnClicked } from '../CustomUtils'
import '../Custom.css'
import ColumnHeadings from '../ColumnHeadings.js'
import ResultsGrid from '../ResultsGrid.js'
import LargeRowHandler from '../LargeRowHandler.js'
import ReportHeading from '../ReportHeading.js'

const RETRIEVEX_REPORT = gql(RETRIEVEX_REPORT_QUERY)

export default function RetrievexReport({ location }) {
  console.log('RetrievexReport rendered:', location)

  const navigate = useNavigate()
  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, RETRIEVEX_REPORT, 'retrievexReport', setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const resultRows = ResultsGrid(results, 0)
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl('BridgePortDepository/retrievexReport/retrievex', location)} resultsLength={results.reportData.length} />
        </div>
        <Table bordered>
          <ReportHeading title={'Retrievex Report'} widths={['0%', '50%', '50%']} />
          <tbody>
            <ColumnHeadings results={results} inputs={getInputParams(location)} sortColumnClicked={sortColumnClicked} location={location} navigate={navigate} setResults={setResults} />
            {resultRows}
          </tbody>
        </Table>
      </div>
    )
  }
}